import { SettlementType, Ticket } from "./Entity";
import { ExpenseType } from "./ExpenseType";

export class Expenses extends Ticket {
  constructor() {
    super();
  }

  // Dados do Ativo
  expenseType: ExpenseType = new ExpenseType();
  expenseTypeId: number = null;
  operationValue: number = null;

  issueDate: Date = null;
  settlementDate: Date = null;

  details: String = null;

  annotations = null;

  // Dados Carteira/Fundo
  portfolioName = "";
  portfolioDocument = "";
  portfolioBank = null;
  portfolioBranch = null;
  portfolioAccount = "";
  portfolioCetipAccount = "";
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;
  settlementTypeId: SettlementType = null;
  isNewFavored: boolean = false;
  favoredName = "";
  favoredDocument = "";
  favoredBank = null;
  favoredBranch = null;
  favoredAccount = null;
  barCode = null;

  tempTicketId: any = null;

  transferStatusDescription: string = null;
}
